import React from 'react';
import { Checkbox } from 'antd';
import { Link } from 'ui-kit';
import './styles.scss';
import { AGREEMENT_ID } from '../CheckoutForm/constants';

export interface IAgreement {
  onChange: (checked: boolean) => void;
}

const Agreement = ({ onChange }: IAgreement) => {
  return (
    <div className="CheckoutForm_customerFormAgreementWrapper" id={AGREEMENT_ID}>
      <div className="CheckoutForm_customerFormAgreement">
        <div className="CheckoutForm_checkoutFormCheckboxWrapper">
          <Checkbox onChange={(e) => onChange(e.target.checked)} />
        </div>
        <div>
          I agree to The Host Co{' '}
          <Link target="_blank" href="https://www.thehost.co/terms-conditions">
            terms of service
          </Link>{' '}
          and{' '}
          <Link target="_blank" href="https://www.thehost.co/privacy-policy">
            privacy policy.
          </Link>{' '}
        </div>
      </div>
      <p>
        I agree to The Host Co’s Terms and Privacy Policy. I understand my purchase may include a
        concierge fee and charges will appear as The Host Co or The Host Company HC Inc. I consent
        to receive information-related texts at the number provided, including messages sent by
        autodialer. Msg & data rates may apply, frequency varies. Reply &quot;stop&quot; to opt out.
      </p>
    </div>
  );
};

export default Agreement;
